import { Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MDBSwitchService } from '../../services/mdb-switch.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

@Component({
  standalone:true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,MdbFormsModule],
  selector: 'app-mdb-switch',
  templateUrl: './mdb-switch.component.html',
  styleUrls: ['./mdb-switch.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MdbSwitchComponent),
    multi: true,
  }]
})
export class MdbSwitchComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() label:string | undefined;
  @Input() id:string = null;
  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};
  controlSwitchName = new UntypedFormControl();
  value = false;
  public takeUntilSubject = new Subject();
  public disabled:boolean 

  constructor(
    public mdbSwitchService: MDBSwitchService
  ) { 
    this.controlSwitchName.valueChanges.pipe(
      takeUntilDestroyed()
    ).subscribe(value => {
      try {
        this.onChangeCallback(value);
      } catch(e) { }
    });

    this.mdbSwitchService.onValueChanges.pipe(
      filter(({ id }) => id === this.id),
      takeUntilDestroyed()
    ).subscribe(({ value, options }) => {
      this.controlSwitchName.setValue(value, options);
    });

    this.mdbSwitchService.onStatusChanges.pipe(
      filter(({ id }) => id === this.id),
      takeUntilDestroyed()
    ).subscribe(({ disabled, options }) => {
      const { controlSwitchName } = this;
      this.disabled = disabled;
      return this.disabled ?
        controlSwitchName.disable(options):
        controlSwitchName.enable(options);
    });

  }
  registerOnChange(fn: any) { 
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }
  writeValue(value: boolean) {
    if(this.controlSwitchName.value === value) {
      return;
    }

    this.controlSwitchName.setValue(value)
  }
  setDisabledState(isDisabled: boolean): void {
    const { controlSwitchName } = this;
    this.disabled = isDisabled;
    this.disabled ? controlSwitchName.disable(): controlSwitchName.enable();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
